/**
 * MSAL Configuration
 * Microsoft Authentication Library configuration for Azure AD
 *
 * Uses runtime configuration (injected at container startup) with fallback to build-time values
 */

import { Configuration, LogLevel } from '@azure/msal-browser';
import {
  getAzureClientId,
  getAzureTenantId,
  getAzureRedirectUri,
} from './runtimeConfig';

export const msalConfig: Configuration = {
  auth: {
    clientId: getAzureClientId(),
    authority: `https://login.microsoftonline.com/${getAzureTenantId() || 'common'}`,
    redirectUri: getAzureRedirectUri(),
    postLogoutRedirectUri: getAzureRedirectUri(),
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
    },
  },
};

// Scopes for Microsoft Graph API
export const loginRequest = {
  scopes: [
    'User.Read',
    'Files.Read.All',
    'Sites.Read.All',
  ],
};

// Token request for Graph API
export const graphTokenRequest = {
  scopes: [
    'https://graph.microsoft.com/User.Read',
    'https://graph.microsoft.com/Files.Read.All',
    'https://graph.microsoft.com/Sites.Read.All',
  ],
};
